/* tslint:disable */
import { Injectable } from '@angular/core';

import { BUSINESS_CONST } from '../../constants/business.constants';
import { OpEnum } from '../../enums/op.enum';
import {
  CiiuModel,
  CityModel,
  CityModelAlt,
  EmployedContractModel,
  FinancialModel,
  OfficeModel,
  OtherFinancialModel,
} from '../../models/abre-cuentas.model';
import { ContactModel } from '../../models/contact.model';
import { OccupationModel } from '../../models/occupation.model';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { ParametersService } from '../parameters/parameters.service';
import { HelpersService } from './helpers-onboarding.service';


@Injectable()
/**
 * Definición de la clase ValidationHelperService, clase con funcionen de ayuda en validaciones
 * 
 * *ValidationHelperService class definition, class with helper validation functions*
 * 
 * @type {class}
 */
export class ValidationHelperService {

  /**
   * Declaración de variable validation como boolean
   * 
   * *Variable validation declaration  as boolean*
   * 
   * @type {boolean}
   */
  validation: boolean;

  /**
   * Declaración de variable contactInfo como ContactModel, recibe la información de contacto del usuario
   * 
   * *Variable contactInfo declaration as ContactModel, receives user's contact*
   * 
   * @type {ContactModel}
   */
  contactInfo: ContactModel;

  /**
   * Declaración de variable officeInfo como OfficeModel, recibe la información de la oficina
   * 
   * *Variable officeInfo declaration as OfficeModel, receives office info*
   * 
   * @type {OfficeModel}
   */
  officeInfo: OfficeModel;

  /**
   * Declaración de variable financialInfo como FinancialModel, recibe la información financiera
   * 
   * *Variable financialInfo declaration as FinancialModel, receives financial info*
   * 
   * @type {FinancialModel}
   */
  financialInfo: FinancialModel;

  /**
   * Declaración de variable OtherFinancialIncomes como OtherFinancialModel, recibe la información de otros ingresos financieros
   * 
   * *Variable OtherFinancialIncomes declaration as OtherFinancialModel, receives other financial info*
   * 
   * @type {OtherFinancialModel}
   */
  otherFinancialInfo: OtherFinancialModel;

  /**
   * Declaración de variable selectedOccupation como OccupationModel, recibe la ocupación seleccionada
   * 
   * *Variable selectedOccupation declaration as OccupationModel, receives occupation selected*
   * 
   * @type {FinancialModel}
   */
  selectedOccupation: OccupationModel;

  /**
   * Declaración de variable dataClient como any, recibe la información del cliente
   * 
   * *Variable dataClient declaration as any, receives client's data*
   * 
   * @type {any}
   */
  dataClient: any;

  /**
   * Declaración de variable options como any[]
   * 
   * *Variable options declaration as any[]*
   * 
   * @type {any[]}
   */
  options: any[];

  /**
   * Declaración de variable selectedCity como CityModel, recibe la ciudad seleccionada
   * 
   * *Variable selectedCity declaration as CityModel, receives selected city*
   * 
   * @type {CityModel}
   */
  selectedCity: CityModel;
  selectedBirthCity: CityModel;

  /**
   * Declaración de variable selectedOfficeCity como CityModel, recibe la ciudad de la oficina
   * 
   * *Variable selectedOfficeCity declaration as CityModel, receives office city selected*
   * 
   * @type {CityModel}
   */
  selectedOfficeCity: CityModel;

  /**
   * Declaración de variable selectedCiiu como CiiuModel, recibe la información de la actividad económica
   * 
   * *Variable selectedCiiu declaration as CiiuModel, receives economical activity info*
   * 
   * @type {CiiuModel}
   */
  selectedCiiu: CiiuModel;

  /**
   * Declaración de variable optionsciiu como any[], recibe las opciones de la actividad económica
   * 
   * *Variable optionsciiu declaration as any[], receives economical activity options*
   * 
   * @type {any[]}
   */
  optionsciiu: any[];

  /**
   * Declaración de variable occupationSelected como OccupationModel, recibe la ocupación seleccionada por el usuario
   * 
   * *Variable occupationSelected declaration as OccupationModel, receives occupation selected by user*
   * 
   * @type {OccupationModel}
   */
  occupationSelected: OccupationModel;

  /**
   * Declaración de variable employedModel como EmployedContractModel, recibe el contrato de empleo del usuario
   * 
   * *Variable employedModel declaration as EmployedContractModel, receives user's emploed contract*
   * 
   * @type {EmployedContractModel}
   */
  employedModel: EmployedContractModel;
  /**
   * Constructor de la clase  
   * *Class Contstructor.*
   * 
   * Inicializa los métodos para los modelos
   * 
   * *Initialize method for models*
   * 
   * @param {AbreCuentasService} abreCuentasService
   * @param {ParametersService} parametersService
   * @param {HelpersService} helperService
   * @var {CityModel} selectedCity
   * @var {CityModel} selectedOfficeCity
   */
  constructor(
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private helperService: HelpersService,
  ) {
    this.selectedBirthCity = new CityModel();
    this.selectedCity = new CityModel();
    this.selectedOfficeCity = new CityModel();
  }

  /**
   * Función para validar la escritura del correo electrónico
   * 
   * *Function to validates email writing*
   * 
   * @type {function}
   * @param {any} value
   * @returns {boolean}
   */
  isValidMail(value: any): boolean {
    const pattern = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
    const regex = new RegExp(pattern);
    return regex.test(value);
  }

  /**
   * Función para validar el número telefónico
   * 
   * *Function to validates phone number*
   * 
   * @type {function}
   * @param {any} value
   * @returns {boolean}
   */
  isValidPhone(value: any): boolean {
    const regex = new RegExp(/^\d{7,10}$/);
    return regex.test(value);
  }

  /**
   * Función para validar la escritura de la dirección
   * 
   * *Function to validates address writing*
   * 
   * @type {function}
   * @param {any} value
   * @returns {boolean}
   */
  isValidAddress(value: any): boolean {
    const regex = new RegExp(/^[Ññ\w-#/., ]+$/);
    return (value === '' || regex.test(value) && (value.length > 8 && value.length < 40));
  }

  /**
   * Función para validar la escritura del nombre de la oficina
   * 
   * *Function to validates office's name writing*
   * 
   * @type {function}
   * @param {any} value
   * @returns {boolean}
   */
  isValidOfficeName(value: any): boolean {
    const regex = new RegExp(/^(?!.*[ ]{2}).+$/);
    return (value === '' || regex.test(value) && (value.length > 3 && value.length < 40));
  }

  /**
   * Función para validar la fecha
   * 
   * *Function to validates date*
   * 
   * @type {function}
   * @param {any} date
   * @returns {boolean}
   */
  isValidDate(date: any): boolean {
    const regex = new RegExp(/^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/);
    return regex.test(date);
  }

  /**
   * validación de los fondos existentes del cliente
   * 
   * *Validates existing client source funds*
   * 
   * @type {function}
   * @returns {boolean}
   */
  setExistingClientSourceOfFunds(other?: boolean): boolean {
    let sourceExist = false;
    const funds = other ? this.dataClient.financial.otherFunds : this.dataClient.financial.funds_source;
    const origins = this.parametersService.getSetting(OpEnum.SOURCE_OF_FUNDS);
    origins.forEach(origin => {
      if (origin.value === funds) {
        this.abreCuentasService.setIncomesOriginSearchSelected(origin);
        sourceExist = true;
      }
    });
    return sourceExist;
  }

  /**
   * validación de los fondos por defecto del cliente
   * 
   * *Validates default client source funds*
   * 
   * @type {function}
   * @returns {boolean}
   */
  setDefaultSourceOfFunds(): boolean {
    let sourceExist = false;
    const occupation = this.abreCuentasService.getOccupationSelected().name;
    const origins = this.parametersService.getSetting(OpEnum.SOURCE_OF_FUNDS);
    origins.forEach(origin => {
      origin.default.forEach(occupationDefault => {
        if (occupation === occupationDefault) {
          this.abreCuentasService.setIncomesOriginSearchSelected(origin);
          sourceExist = true;
        }
      });
    });
    return sourceExist;
  }

  /**
   * Validación de cambios en acuerdos de nómina de sueldos
   * 
   * *Validates changed payroll agreement*
   * 
   * @type {function}
   * @returns {boolean}
   */
  changedPayrollAgreement(): boolean {
    if (this.abreCuentasService.getproductSelected().product_type === 'payroll') {
      const validation = true;
      this.dataClient.financial.labor_company = this.abreCuentasService.getAgreementSelected().agreement_name;
      return !validation;
    }
    return false;
  }

  /**
   * Formato del texto de la actividad profesional a un código
   * 
   * *Format professional activity text*
   * 
   * @type {function}
   */
  formatProfessionalActivity() {
    let name = this.dataClient.basic.professional_activity[0].name;
    if (this.selectedOccupation.name === 'Independiente' && !!name) {
      name = name.toString().replace(/^(\d{1})$/g, '00$1').replace(/^(\d{2})$/g, '0$1');
      this.dataClient.basic.professional_activity[0].name = name;
    }
  }

  /**
   * Filtra la lista de ciudades por sus nombres
   * 
   * *Filter city by names and department*
   * 
   * @type {function}
   * @returns {string}
   */
  filterCityByNames(city: string, department: string): string {
    const newDepartment = city === 'BOGOTA D.C.' ? 'BOGOTA D.C.' : department;
    this.options = this.parametersService.getSetting(OpEnum.CITY_LIST);
    const codes = this.options.filter((element: CityModelAlt, _index, _array: CityModelAlt[]) => {
      return this.abreCuentasService.normalize(element.description.split(',')[1]) === this.abreCuentasService.normalize(newDepartment) &&
        this.abreCuentasService.normalize(element.description.split(',')[0]) === this.abreCuentasService.normalize(city);
    })[0];
    // return codes.province_code.toString() + codes.city_code + '';
    return codes ? codes.province_code.toString() + codes.city_code + '' : city; 
  }

  /**
   * Aplica una mascara al número teléfonico
   * 
   * *Applies mask to phone number*
   * 
   * @type {function}
   * @param {string} phone
   * @returns {string}
   */
  maskPhone(phone: string): string {
    return phone.replace(/\d(?=\d{4})/g, '*');
  }

  /**
   * Aplica una mascara al correo electrónico
   * 
   * *Applies mask to email*
   * 
   * @type {function}
   * @param {string} phone
   * @returns {string}
   */
  maskMail(mail: string): string {
    const asteriks = mail.replace(/\b([^@]{1,2})([^@]*)@([^s]*)/, '$2');
    if (asteriks === '') {
      return mail.replace(/\b([^@]{1,2})([^@]*)@([^s]*)/, '$1' + '@' + '$3');
    }
    return mail.replace(/\b([^@]{1,2})([^@]*)@([^s]*)/, '$1' + asteriks.replace(/[\w]/g, '*') + '@' + '$3');
  }

  /**
   * Valida un contacto
   * 
   * *Validate a contact*
   * 
   * @type {function}
   * @returns {boolean}
   */
  validateMailPhone(): boolean {
    this.dataClient = this.abreCuentasService.getCustomerData();
    if (
      (
        this.dataClient.contact !== undefined
      )
      &&
      (
        (
          this.dataClient.contact.email === undefined ||
          this.dataClient.contact.email.trim() === '' ||
          !this.isValidMail(this.dataClient.contact.email.toLowerCase())
        ) ||
        (
          this.dataClient.contact.phones === undefined ||
          this.dataClient.contact.phones[0].phone_type !== '1-Mobile' ||
          this.dataClient.contact.phones[0].phone_number === undefined ||
          this.dataClient.contact.phones[0].phone_number.trim() === '' ||
          !this.isValidPhone(this.dataClient.contact.phones[0].phone_number)
        )
      )
    ) {
      return false;
    } else {
      return true;
    }
  }

  /* istanbul ignore next */
  /**
   * Valida la existencia del cliente
   * 
   * *Applies mask to email*
   * 
   * @type {function}
   * @returns {boolean}
   */
  isValidExistingClient(): boolean {
    try {
      const productSelected = this.abreCuentasService.getproductSelected();
      const product_type = productSelected ? productSelected.product_type : '';

      this.dataClient = this.abreCuentasService.getCustomerData();
      this.selectedOccupation = this.abreCuentasService.getOccupationSelected();

      this.formatProfessionalActivity();

      if (this.changedPayrollAgreement()) {
        return false;
      }

      if (this.dataClient.basic === undefined ||
        this.dataClient.financial === undefined ||
        this.dataClient.contact === undefined ||
        this.dataClient.address === undefined) {
        return false;
      }
      const address = this.dataClient.address.addresses.find(e => e.type === '1');
      if (!address) {
        return false;
      }
      const addressOffice = this.dataClient.address.addresses.find(e => e.type === '2' || e.type === '3' || e.type === '5');

      if (address.city === undefined || address.city.trim() === '') {
        return false;
      }
      if (address.street === undefined || address.street.trim() === '') {

        return false;
      }

      if (this.dataClient.basic.housing_type === undefined || this.dataClient.basic.housing_type.trim() === '') {

        return false;
      }

      if (this.dataClient.basic.social_class === undefined || this.dataClient.basic.social_class.trim() === '') {

        return false;
      }

      if (this.dataClient.basic.marital_status === undefined || this.dataClient.basic.marital_status.trim() === '') {

        return false;
      }


      if (this.dataClient.contact.email === undefined || this.dataClient.contact.email.trim() === '') {
        return false;
      }

      if (!this.isValidMail(this.dataClient.contact.email.toLowerCase())) {
        return false;
      }

      if (this.dataClient.contact.phones[0].phone_number === undefined || this.dataClient.contact.phones[0].phone_number.trim() === '') {
        return false;
      }

      if (!this.isValidPhone(this.dataClient.contact.phones[0].phone_number)) {
        return false;
      }

      if (this.selectedOccupation.name === undefined || this.selectedOccupation.name.trim() === '') {
        return false;
      }
      if (this.selectedOccupation.name === 'Empleado' || this.selectedOccupation.name === 'Independiente') {

        if (this.dataClient.financial.company_start_date === undefined || this.dataClient.financial.company_start_date.trim() === '') {

          return false;
        }

        if (this.selectedOccupation.name === 'Empleado') {
          if (this.dataClient.financial.labor_company === undefined || this.dataClient.financial.labor_company.trim() === '') {
            return false;
          }
          if (this.dataClient.financial.labor_contract_type === undefined || this.dataClient.financial.labor_contract_type.trim() === '') {
            return false;
          }
        }

        if (this.selectedOccupation.name === 'Independiente' && !this.dataClient.basic.professional_activity[0].name) {
          return false;
        }
        if (!(this.selectedOccupation.name === 'Independiente' && this.dataClient.basic.professional_activity[0].name === '090')) {
          if (!addressOffice) {
            return false;
          }

          if (addressOffice.street === undefined || addressOffice.street.trim() === '') {
            return false;
          }

          if (addressOffice.city === undefined || addressOffice.city.trim() === '') {
            return false;
          }

          if (this.dataClient.financial.labor_company === undefined || this.dataClient.financial.labor_company.trim() === '') {
            return false;
          }

          const mobilePhoneOffice = this.dataClient.contact.phones.find(e => {
            const code = e.phone_type.split('-')[0];
            if (code === '2' || code === '3' || code === '5') {
              return e;
            }
          },
          );
          if (mobilePhoneOffice === undefined) {
            return false;
          }
          if (mobilePhoneOffice.phone_number === undefined || mobilePhoneOffice.phone_number.trim() === '') {
            return false;
          }

        }
      }

      if (this.dataClient.financial.active_amount === undefined || this.dataClient.financial.active_amount.amount === undefined) {
        return false;
      }

      if (this.dataClient.financial.passive_amount === undefined || this.dataClient.financial.passive_amount.amount === undefined) {
        return false;
      }

      if (this.dataClient.financial.principal_income === undefined || this.dataClient.financial.principal_income.amount === undefined) {
        return false;
      }

      if (this.dataClient.financial.monthly_outcome === undefined || this.dataClient.financial.monthly_outcome.amount === undefined) {
        return false;
      }

      if (this.dataClient.financial.monthly_outcome === undefined || this.dataClient.financial.monthly_outcome.amount === undefined) {
        return false;
      }

      let sourceExist = false;
      const funds = this.dataClient.financial.funds_source;
      const origins = this.parametersService.getSetting(OpEnum.SOURCE_OF_FUNDS);
      origins.forEach(origin => {
        if (origin.value === funds) {
          sourceExist = true;
        }
      });

      if (!sourceExist) {
        return false;
      }
      if (!this.setExistingClientSourceOfFunds()) {
        return false;
      }
      if (product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
        if (this.selectedOccupation.name !== 'Pensionado') {
          const laborDate = this.dataClient.financial.company_start_date.trim();
          const actual = (new Date()).toLocaleDateString();
          const resultDate = this.helperService.compareDates(actual, laborDate);
          if (laborDate === undefined || laborDate === '' || !this.isValidDate(laborDate)) {
            return false;
          }

          if (this.selectedOccupation.name === 'Empleado') {
            const contractType = this.dataClient.financial.labor_contract_type.trim();
            if (contractType === undefined || contractType === '' || !(contractType === 'Indefinido' || contractType === 'Termino Fijo'
              || contractType === 'Prestacion de Servic')) {
              return false;
            }
            if (!(resultDate >= (this.employedModel.typeContract.timeMin * 30))) {
              return false;
            }
          } else if (this.selectedOccupation.name === 'Independiente') {
            const confTime = this.parametersService.getSetting(OpEnum.OCUPATION_TIME_TC);
            const requiredTimeIndependent = confTime ? confTime.independent_time.timeMin : 24;
            if (!(resultDate >= (requiredTimeIndependent * 30))) {
              return false;
            }
          }
        }

        if (this.occupationSelected !== undefined) {
          const smlv = this.abreCuentasService.getAbreCuentasConfigs()['smlv'] || 0;
          const minValue = (this.occupationSelected.minimun_inflicted_incomes || 0) * smlv;
          const ammountWithDecimals = this.dataClient.financial.principal_income;
          const valor =
            + ammountWithDecimals.amount.toString().substr(0, ammountWithDecimals.amount.toString().length - ammountWithDecimals.decimals);
          if (+ valor < minValue) {
            return false;
          }
        }
      }

      return true;
    } catch (ex) {
      return false;
    }
  }

  filterDocumentType(documentType: string) {
    switch (documentType) {
      case 'CC':
        documentType = '1'
        break;
      case 'CE':
        documentType = '2'
        break;
      case 'PA':
        documentType = '5'
        break;
      default:
        documentType = '1'
        break;
    }
    return documentType
  }

  /* istanbul ignore next */

  /**
   * Inicializa la información del cliente
   * 
   * *Sets custormer data client*
   * 
   * @type {function}
   * @returns {boolean}
   */
  setCustomerDataClient() {
    this.dataClient = this.abreCuentasService.getCustomerData();
    const basicData = this.dataClient.basic;
    const occupation = this.abreCuentasService.getOccupationSelected();
    this.abreCuentasService.setBasictInfo(basicData);
    // let occupationListName = this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ?
    //   OpEnum.OCCUPATIONS_LIST_TC : OpEnum.OCCUPATIONS_LIST;
      let occupationListName = '';
      occupationListName = this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ?
       OpEnum.OCCUPATIONS_LIST_TC : OpEnum.OCCUPATIONS_LIST;
      const product_type = this.abreCuentasService.getproductSelected().product_type;
      if ( product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ){
        let validlist = this.parametersService.getSetting(occupationListName);
         let validlist2 = validlist.find(occupation => occupation.name === basicData.profession);
         if(!validlist2){
          occupationListName = product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ? OpEnum.OCCUPATIONS_LIST 
          : OpEnum.OCCUPATIONS_LIST_TC;
         }
       }
    const occupationList = this.parametersService.getSetting(occupationListName);
    // this.occupationSelected = occupation.name ? occupation : occupationList.find(occupation => occupation.name === basicData.profession);
    if(occupation && occupation.id){
      this.occupationSelected = occupation;
    }else {
      let ocupationfind = occupationList.find(occupation => occupation.name === basicData.profession);
      if (ocupationfind){
        this.occupationSelected = ocupationfind;
      } else {
        this.occupationSelected = new OccupationModel();
        this.occupationSelected.name = basicData.profession;
      }
    }
    this.abreCuentasService.setOccupationSelected(this.occupationSelected);
    this.setExistingClientSourceOfFunds();
    this.options = this.parametersService.getSetting(OpEnum.CITY_LIST);
    const birthCity = this.abreCuentasService.filterCity(basicData.birth_city,
      parseInt(basicData.birth_state_prov, 10), this.options);
    if (basicData.document.type == 1) {
      if (birthCity === undefined || birthCity === null) {
        this.selectedBirthCity = {
          country_code: '',
          province_code: 0,
          city_code: '',
          description: '',
        };
      } else {
      this.selectedBirthCity = {
        country_code: birthCity.country_code ? birthCity.country_code.toString() : '',
        province_code: birthCity.province_code,
        city_code: birthCity.city_code,
        description: birthCity.description,
      }
    }; 
      this.abreCuentasService.setBirthplaceInfo(this.selectedBirthCity);
    }
    this.selectedCiiu = this.abreCuentasService.getCiiuSelected();
    this.optionsciiu = this.parametersService.getSetting(OpEnum.CIIU_LIST) || [];
    this.optionsciiu = this.optionsciiu.map(option => ({ ...option, large_description: `${option.ciiu} - ${option.description}` }));
    const address = this.dataClient.address.addresses.find(e => e.type === '1');
    const addressOffice = this.dataClient.address.addresses.find(e => e.type === '2' || e.type === '3' || e.type === '5');
    const mobilePhone = this.dataClient.contact.phones.find(e => e.phone_type.split('-')[0] === '1');
    const mobilePhoneOffice = this.dataClient.contact.phones.find(e => {
      const code = e.phone_type.split('-')[0];
      if (code === '2' || code === '3' || code === '5') {
        return e;
      }
    },
    );
    this.contactInfo = {
      mobile_number: mobilePhone && this.isValidPhone(mobilePhone.phone_number) ? mobilePhone.phone_number : '',
      email:
        this.dataClient.contact.email && this.isValidMail(this.dataClient.contact.email.toLowerCase()) ?
          this.dataClient.contact.email.toLowerCase() : '',
      address: {
        // city: null,
        city: {
          city_code: '',
          description: '',
          country_code: '',
          province_code: 0,
        },
        address: '',
        detail: '',
        addressInput: '',
        housingType: {
          housingId: '',
          description: ''
        },
        stratum: '',
      },
      // employment_number: null
      employment_number: '',
    };
    this.officeInfo = {
      occupation_id: 0,
      company_name: '',
      company_nameInput: '',
      address: {
        city: new CityModel(),
        address: '',
        detail: '',
        addressInput: '',
      },
      office_number:
        mobilePhoneOffice && this.isValidPhone(mobilePhoneOffice.phone_number) ? mobilePhoneOffice.phone_number : '',
    };
    if (address) {
      const city = this.options.find(e =>
        e.city_code === address.city && e.province_code === parseInt(address.district, 10));
      if (city) {
        this.contactInfo.address = {
          city,
          address: this.isValidAddress(address.street) ? address.street : '',
          detail: address.complement ? address.complement : '',
          addressInput: this.isValidAddress(address.street) ? address.street : '',
          housingType: {
            housingId: '',
            description: this.helperService.validateDiacritialMask(basicData.housing_type),
          },
          stratum: basicData.social_class,
        };
        this.selectedCity = city;
      }
    }
    if (addressOffice) {
      const cityOffice = this.options.find(e =>
        e.city_code === addressOffice.city && e.province_code === parseInt(addressOffice.district, 10));
      if (cityOffice) {
        const addressValidation = this.isValidAddress(addressOffice.street) ? addressOffice.street : ''
        this.officeInfo.address = {
          city: cityOffice,
          address: addressValidation,
          detail: addressOffice.complement ? addressOffice.complement : '',
          addressInput: addressValidation,
        };
        this.selectedOfficeCity = cityOffice;
      }
    }

    const civilStatusList = this.parametersService.getSetting(OpEnum.CIVIL_STATUS_LIST);  
    const statusMarital = civilStatusList.find(status => { 
      return (status.value.localeCompare(basicData.marital_status, 'es', { sensitivity: 'base'}) === 0)
    });
    let marital_state: any;
    this.abreCuentasService.setContactInfo(this.contactInfo);
    if (statusMarital) {
      marital_state = {
        marital_status_code: statusMarital.id,
        marital_status_description: this.helperService.validateDiacritialMask(basicData.marital_status),
      }
    }
    this.abreCuentasService.setMaritalStatusInfo(marital_state);
    this.selectedCiiu = this.optionsciiu.find(activity => activity.ciiu === basicData.professional_activity.find(
      (item: { key: string, name: string }) => item.key === 'sic').name.
      toString().replace(/^(\d{1})$/g, '00$1').replace(/^(\d{2})$/g, '0$1'));

    if (this.selectedCiiu === undefined) {
      this.selectedCiiu = {
        sector_code: 0,
        ciiu: '',
        description: '',
        large_description: '',
        next: false,
      };

    }
    this.abreCuentasService.setCiiuSelected(this.selectedCiiu);

    this.employedModel = this.abreCuentasService.getEmployedContractModel();

    if (this.abreCuentasService.haveLoan) {
      const confTime = this.parametersService.getSetting(OpEnum.LIST_TYPE_CONTRACT_LOAN);
      const optionsContract: any[] = confTime ? confTime : this.abreCuentasService.getListTypeContract();
      switch (this.dataClient.financial.labor_contract_type) {
        case 'Termino Fijo':
          this.employedModel.typeContract = optionsContract.find(data => (data.elementId === 1));
          break;
        case 'Indefinido':
          this.employedModel.typeContract = optionsContract.find(data => (data.elementId === 2));
          break;
        case 'Prestacion de Servic':
          this.employedModel.typeContract = optionsContract.find(data => (data.elementId === 3));
          break;
        case 'Carrera Administrati':
          this.employedModel.typeContract = optionsContract.find(data => (data.elementId === 4));
          break;
        case 'Libre Nombramiento':
          this.employedModel.typeContract = optionsContract.find(data => (data.elementId === 5));
          break;
        case 'Provisional':
          this.employedModel.typeContract = optionsContract.find(data => (data.elementId === 6));
          break;
        case 'Catedrático':
          this.employedModel.typeContract = optionsContract.find(data => (data.elementId === 7));
          break;
        case 'Obra o Labor':
          this.employedModel.typeContract = optionsContract.find(data => (data.elementId === 8));
          break;
        default:
          this.employedModel.typeContract = {
            label: '',
            elementId: 0,
            checked: false,
            message: '',
            timeText: '',
            timeMin: 0,
          };
          break;
      }
    } else {
      const confTime = this.parametersService.getSetting(OpEnum.OCUPATION_TIME_TC);
      const optionsContract: any[] = confTime ? confTime.list_dependent_time : this.abreCuentasService.getListTypeContract();
      switch (this.dataClient.financial.labor_contract_type) {
        case 'Indefinido':
          this.employedModel.typeContract = optionsContract.find(data => (data.elementId === 2));
          break;
        case 'Termino Fijo':
          this.employedModel.typeContract = optionsContract.find(data => (data.elementId === 1));
          break;
        case 'Prestacion de Servic':
          this.employedModel.typeContract = optionsContract.find(data => (data.elementId === 3));
          break;
        default:
          this.employedModel.typeContract = {
            label: '',
            elementId: 0,
            checked: false,
            message: '',
            timeText: '',
            timeMin: 0,
          };
          break;
      }
    }
    const companyStartDate = this.dataClient.financial.company_start_date.trim();
    this.employedModel.contractDate = companyStartDate;
    this.abreCuentasService.setCiiuDate(companyStartDate);
    this.abreCuentasService.setEmployedContractModel(this.employedModel);
    this.financialInfo = this.abreCuentasService.getFinancialInfo();
    this.financialInfo.goods = this.dataClient.financial.active_amount ? this.dataClient.financial.active_amount.amount : 0;
    const goodsDecimals = this.dataClient.financial.active_amount ? this.dataClient.financial.active_amount.decimals : 0;
    this.financialInfo.goods = (this.financialInfo.goods -
      (this.financialInfo.goods % Math.pow(10, goodsDecimals))) / Math.pow(10, goodsDecimals);
    this.financialInfo.debt = this.dataClient.financial.passive_amount ? this.dataClient.financial.passive_amount.amount : 0;
    const debtDecimals = this.dataClient.financial.passive_amount ? this.dataClient.financial.passive_amount.decimals : 0;
    this.financialInfo.debt = (this.financialInfo.debt -
      (this.financialInfo.debt % Math.pow(10, debtDecimals))) / Math.pow(10, debtDecimals);
    this.financialInfo.incomes = this.dataClient.financial.principal_income ? this.dataClient.financial.principal_income.amount : 0;
    const incomesDecimals = this.dataClient.financial.principal_income ? this.dataClient.financial.principal_income.decimals : 0;
    this.financialInfo.incomes = (this.financialInfo.incomes -
      (this.financialInfo.incomes % Math.pow(10, incomesDecimals))) / Math.pow(10, incomesDecimals);
    this.financialInfo.expenses = this.dataClient.financial.monthly_outcome ? this.dataClient.financial.monthly_outcome.amount : 0;
    const expensesDecimals = this.dataClient.financial.monthly_outcome ? this.dataClient.financial.monthly_outcome.decimals : 0;
    this.financialInfo.expenses = (this.financialInfo.expenses -
      (this.financialInfo.expenses % Math.pow(10, expensesDecimals))) / Math.pow(10, expensesDecimals);
    this.financialInfo.funds = this.abreCuentasService.getIncomesOriginSearchSelected().value;
    this.abreCuentasService.setFinancialInfo(this.financialInfo);
    this.officeInfo.company_name =
      this.isValidOfficeName(this.dataClient.financial.labor_company) ? this.dataClient.financial.labor_company : '';
    // this.abreCuentasService.setOfficeInfo(this.occupationSelected.id.toString(), this.officeInfo);
    this.occupationSelected && this.occupationSelected.id ?
    this.abreCuentasService.setOfficeInfo(this.occupationSelected.id.toString(), this.officeInfo) :
    '';
    const incomes = this.dataClient.basic.alternative_incomes ? this.dataClient.basic.alternative_incomes : {
      decimals: 0,
      amount: 0
    }
    const powDecimals = Math.pow(10, incomes.decimals);
    const otherIncomesAmount = incomes.amount;
    this.otherFinancialInfo = {
      otherIncomes: otherIncomesAmount !== 0 ? + (otherIncomesAmount - (otherIncomesAmount % powDecimals)) / powDecimals : 0,
      otherFunds: otherIncomesAmount !== 0 ? this.dataClient.basic.alternative_incomes_type : '',
    };
    this.abreCuentasService.setOtherFinancialInfo(this.otherFinancialInfo);
  }
  /**
   * Valida duplicidad de productos
   * 
   * *vvalidate duplicate products*
   * 
   * @type {function}
   * @returns {boolean}
   */
  validationOfProductDuplicity(product_sub_type: string): boolean {
    return this.abreCuentasService.getAbreCuentasConfigs().blockedProductsByProductCode[this.abreCuentasService.getproductSelected().product_type].find((productCode: string) => productCode === product_sub_type);
  }

  /**
  * Valida si el producto seleccionado es del pasivo
  * 
  * *validate if selected product is passiveduplicate products*
  * 
  * @type {function}
  * @returns {boolean}
  */
  isPassiveProduct(): boolean {
    const productType = this.abreCuentasService.getproductSelected().product_type
    return productType === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL || productType === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS ? true : false;
  }

  /**
 * Valida si el producto seleccionado es del pasivo
 * 
 * *validate if selected product is passiveduplicate products*
 * 
 * @type {function}
 * @returns {boolean}
 */
  splitNames(names: string, lastnames: string) {
    const given_names = names.trim().split(' ');
    const family_names = lastnames.trim().split(' ');
    const res = {
      firstname: given_names[0],
      middlename: given_names[1] === undefined ? '' : given_names[1],
      primary_lastname: family_names[0],
      second_lastname: family_names[1] === undefined ? '' : family_names[1],
    }
    return res;
  }

  /**
 * transforma incomes de PCO
 * 
 * *validate incomes PCO*
 * 
 * @type {function}
 * @returns {boolean}
 */
  setIncomes(data: any) {
    const respco = {
      account_type: '',
      income_amount: {
        currency: 'COP',
        amount: 0,
        decimals: 2
      },
      income_type: '',
      segment_id: '',
      source_type: '',
    }
    data.map(item => {
      if (this.helperService.validateDiacritialMask(item.key) === 'Respuesta') {
        respco.source_type = item.name;
      }
      if (this.helperService.validateDiacritialMask(item.key) === 'Valor') {
        respco.income_amount.amount = item.name;
      }
      if (this.helperService.validateDiacritialMask(item.key) === 'Tipoingreso') {
        respco.income_type = item.name;
      }
      if (this.helperService.validateDiacritialMask(item.key) === 'Segmento') {
        respco.segment_id = item.name.toString();
      }
      if (this.helperService.validateDiacritialMask(item.key) === 'Tipocuenta') {
        respco.account_type = item.name;
      }
    });
    return respco;
  }

  ispurchase() {
    const simulatorData = this.abreCuentasService.getOtherSimulationData();
    return (simulatorData.sub_product === 'LEA' &&
      (simulatorData.code === '01' || simulatorData.code === '07' || simulatorData.code === '03')) ? true : false;
  }
}


